import { Component } from '@angular/core';

@Component({
    selector: 'vp-no-sales-force-access',
    templateUrl: './no-sales-force-access.component.html',
    styleUrls: ['../errors.scss'],
    standalone: false
})
export class NoSalesForceAccessComponent {}
